export default __webpack_public_path__ + "static/media/safe-area.8cc94955.png";